module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1031.fa912e5e.png";